import React, { FC, useCallback } from 'react';
import loadable from '@loadable/component';
import { Loading } from '@moda/om';
import { useAuthModal } from '../../../hooks/useAuthModal';
import { ModalOverlay } from '../../Modal';

const Authentication = loadable(() => import('../Authentication'), {
  resolveComponent: exports => exports.Authentication,
  fallback: <Loading />
});

export const AuthenticationModal: FC = () => {
  const { show, closeAuthModal, handleAuthSuccess } = useAuthModal();

  const handleAuth = useCallback(() => {
    handleAuthSuccess();
    closeAuthModal();
  }, [closeAuthModal, handleAuthSuccess]);

  return (
    <ModalOverlay data-testid="authentication-modal" onClose={closeAuthModal} show={show}>
      <Authentication onAuth={handleAuth} modal />
    </ModalOverlay>
  );
};
